import Cookies from 'js-cookie';

class ThinClient {
	/**
	 * Determine if the application is running in ThinClient.
	 * @returns {boolean}
	 */
	static isInThinClient = () => Cookies.get('IsThinClient') === 'true';
}

export default ThinClient;
